import { Impulse, type Scope } from "~/tools/impulse";

/**
 * The state keeps track of expanded items.
 * It is necessary to keep track of them somewhere,
 * because it should sustain the values even if the component is unmounted.
 */
export class ToggleListState {
	private readonly set = Impulse<ReadonlySet<string>>(new Set<string>());

	public isExpanded(scope: Scope, key: string): boolean {
		return this.set.getValue(scope).has(key);
	}

	public expand(key: string, isExpanded: boolean): void {
		this.set.setValue((set) => {
			if (set.has(key) === isExpanded) {
				return set;
			}

			const clone = new Set(set);

			if (isExpanded) {
				clone.add(key);
			} else {
				clone.delete(key);
			}

			return clone;
		});
	}
}
